const TESTNET_PURCHASE_TRANSACTION = `import MagnetiqAlphaOne from 0x651fd50c5ca7d66c
import NonFungibleToken from 0x631e88ae7f1d7c20
import MetadataViews from 0x631e88ae7f1d7c20
import DapperUtilityCoin from 0x82ec283f88a62e65
import FungibleToken from 0x9a0766d93b6608b7
import NFTStorefrontV2 from 0x2d55b98eb200daef
// This transaction was auto-generated with the NFT Catalog (https://github.com/dapperlabs/nft-catalog)
//
// This transaction purchases an NFT from a dapp directly (i.e. **not** on a peer-to-peer marketplace).
//
// Collection Identifier: Magnetiq
// Vault Identifier: duc
//
// Version: 0.1.1
transaction(merchantAccountAddress: Address, storefrontAddress: Address, listingResourceID: UInt64, expectedPrice: UFix64) {
    /* This transaction purchases an NFT from a dapp directly (i.e. **not** on a peer-to-peer marketplace). */
   
    /// merchantAccountAddress - The merchant account address provided by Dapper Labs
    /// storefrontAddress - The address that owns the storefront listing
    /// listingResourceID - ID of the Storefront listing resource
    /// expectedPrice: UFix64 - How much you expect to pay for the NFT
   
    let paymentVault: @FungibleToken.Vault
    let nftCollection: &MagnetiqAlphaOne.Collection{MagnetiqAlphaOne.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}
    let storefront: &NFTStorefrontV2.Storefront{NFTStorefrontV2.StorefrontPublic}
    let listing: &NFTStorefrontV2.Listing{NFTStorefrontV2.ListingPublic}
    let salePrice: UFix64
    let balanceBeforeTransfer: UFix64
    let mainUtilityCoinVault: &DapperUtilityCoin.Vault
   
    prepare(dapper: AuthAccount, buyer: AuthAccount) {
       
        // Initialize the buyer's collection if they do not already have one
        if buyer.borrow<&MagnetiqAlphaOne.Collection>(from: /storage/MagnetiqAlphaOneTokensCollection) == nil {
            let collection <- MagnetiqAlphaOne.createEmptyCollection() as! @MagnetiqAlphaOne.Collection
            buyer.save(<-collection, to: /storage/MagnetiqAlphaOneTokensCollection)
        }
        if (buyer.getCapability<&MagnetiqAlphaOne.Collection{MagnetiqAlphaOne.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}>(/public/MagnetiqAlphaOneTokensCollection).borrow() == nil) {
            buyer.unlink(/public/MagnetiqAlphaOneTokensCollection)
            buyer.link<&MagnetiqAlphaOne.Collection{MagnetiqAlphaOne.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}>(/public/MagnetiqAlphaOneTokensCollection, target: /storage/MagnetiqAlphaOneTokensCollection)
        }
        if (buyer.getCapability<&MagnetiqAlphaOne.Collection{NonFungibleToken.Provider,MagnetiqAlphaOne.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}>(/private/MagnetiqAlphaOneTokensCollection).borrow() == nil) {
            buyer.unlink(/private/MagnetiqAlphaOneTokensCollection)
            buyer.link<&MagnetiqAlphaOne.Collection{NonFungibleToken.Provider,MagnetiqAlphaOne.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}>(/private/MagnetiqAlphaOneTokensCollection, target: /storage/MagnetiqAlphaOneTokensCollection)
        }
        self.storefront = getAccount(storefrontAddress)
            .getCapability<&NFTStorefrontV2.Storefront{NFTStorefrontV2.StorefrontPublic}>(
                NFTStorefrontV2.StorefrontPublicPath
            )!
            .borrow()
            ?? panic("Could not borrow Storefront from provided address")
        // Get the listing by ID from the storefront
        self.listing = self.storefront.borrowListing(listingResourceID: listingResourceID)
            ?? panic("No Offer with that ID in Storefront")
        self.salePrice = self.listing.getDetails().salePrice
        // Get a vault from Dapper's account
        self.mainUtilityCoinVault = dapper.borrow<&DapperUtilityCoin.Vault>(from: /storage/dapperUtilityCoinVault)
            ?? panic("Cannot borrow UtilityCoin vault from account storage")
        self.balanceBeforeTransfer = self.mainUtilityCoinVault.balance
        self.paymentVault <- self.mainUtilityCoinVault.withdraw(amount: self.salePrice)
        // Get the collection from the buyer so the NFT can be deposited into it
        self.nftCollection = buyer.borrow<&MagnetiqAlphaOne.Collection{MagnetiqAlphaOne.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}>(
            from: /storage/MagnetiqAlphaOneTokensCollection
        ) ?? panic("Cannot borrow NFT collection receiver from account")
    }
    // Check that the price is right
    pre {
        self.salePrice == expectedPrice: "unexpected price"
    }
    execute {
        let item <- self.listing.purchase(
            payment: <-self.paymentVault,
            commissionRecipient: nil
        )
        self.nftCollection.deposit(token: <-item)
    }
    // Check that all utilityCoin was routed back to Dapper
    post {
        self.mainUtilityCoinVault.balance == self.balanceBeforeTransfer: "UtilityCoin leakage"
    }
}`;

const TESTNET_USER_ACCOUNT_SETUP_TXN = `import NonFungibleToken from 0x631e88ae7f1d7c20
import MagnetiqAlphaOne from 0x651fd50c5ca7d66c
import MetadataViews from 0x631e88ae7f1d7c20
// This transaction sets up an account to use Magnetiq
// by storing an empty moment collection and creating
// a public capability for it
transaction {
    prepare(acct: AuthAccount) {
        // First, check to see if a moment collection already exists
        if acct.borrow<&MagnetiqAlphaOne.Collection>(from: /storage/MagnetiqAlphaOneTokensCollection) == nil {
            // create a new Magnetiq Collection
            let collection <- MagnetiqAlphaOne.createEmptyCollection() as! @MagnetiqAlphaOne.Collection
            // Put the new Collection in storage
            acct.save(<-collection, to: /storage/MagnetiqAlphaOneTokensCollection)
            // create a public capability for the collection
            acct.link<&{NonFungibleToken.CollectionPublic, MagnetiqAlphaOne.TokenCollectionPublic}>(/public/MagnetiqAlphaOneTokensCollection, target: /storage/MagnetiqAlphaOneTokensCollection)
        }
    }
}`;

const MAINNET_PURCHASE_TRANSACTION = `import Magnetiq from 0x5257f1455ed366fe
import NonFungibleToken from 0x1d7e57aa55817448
import MetadataViews from 0x1d7e57aa55817448
import DapperUtilityCoin from 0xead892083b3e2c6c
import FungibleToken from 0xf233dcee88fe0abe
import NFTStorefrontV2 from 0x4eb8a10cb9f87357
// This transaction was auto-generated with the NFT Catalog (https://github.com/dapperlabs/nft-catalog)
//
// This transaction purchases an NFT from a dapp directly (i.e. **not** on a peer-to-peer marketplace).
//
// Collection Identifier: Magnetiq
// Vault Identifier: duc
//
// Version: 0.1.1
transaction(merchantAccountAddress: Address, storefrontAddress: Address, listingResourceID: UInt64, expectedPrice: UFix64) {
    /* This transaction purchases an NFT from a dapp directly (i.e. **not** on a peer-to-peer marketplace). */
    /// merchantAccountAddress - The merchant account address provided by Dapper Labs
    /// storefrontAddress - The address that owns the storefront listing
    /// listingResourceID - ID of the Storefront listing resource
    /// expectedPrice: UFix64 - How much you expect to pay for the NFT
    let paymentVault: @FungibleToken.Vault
    let nftCollection: &Magnetiq.Collection{Magnetiq.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}
    let storefront: &NFTStorefrontV2.Storefront{NFTStorefrontV2.StorefrontPublic}
    let listing: &NFTStorefrontV2.Listing{NFTStorefrontV2.ListingPublic}
    let salePrice: UFix64
    let balanceBeforeTransfer: UFix64
    let mainUtilityCoinVault: &DapperUtilityCoin.Vault
    prepare(dapper: AuthAccount, buyer: AuthAccount) {
        // Initialize the buyer's collection if they do not already have one
        if buyer.borrow<&Magnetiq.Collection>(from: /storage/MagnetiqTokensCollection) == nil {
            let collection <- Magnetiq.createEmptyCollection() as! @Magnetiq.Collection
            buyer.save(<-collection, to: /storage/MagnetiqTokensCollection)
        }
        if (buyer.getCapability<&Magnetiq.Collection{Magnetiq.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}>(/public/MagnetiqTokensCollection).borrow() == nil) {
            buyer.unlink(/public/MagnetiqTokensCollection)
            buyer.link<&Magnetiq.Collection{Magnetiq.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}>(/public/MagnetiqTokensCollection, target: /storage/MagnetiqTokensCollection)
        }
        if (buyer.getCapability<&Magnetiq.Collection{NonFungibleToken.Provider,Magnetiq.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}>(/private/MagnetiqTokensCollection).borrow() == nil) {
            buyer.unlink(/private/MagnetiqTokensCollection)
            buyer.link<&Magnetiq.Collection{NonFungibleToken.Provider,Magnetiq.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}>(/private/MagnetiqTokensCollection, target: /storage/MagnetiqTokensCollection)
        }
        self.storefront = getAccount(storefrontAddress)
            .getCapability<&NFTStorefrontV2.Storefront{NFTStorefrontV2.StorefrontPublic}>(
                NFTStorefrontV2.StorefrontPublicPath
            )!
            .borrow()
            ?? panic("Could not borrow Storefront from provided address")
        // Get the listing by ID from the storefront
        self.listing = self.storefront.borrowListing(listingResourceID: listingResourceID)
            ?? panic("No Offer with that ID in Storefront")
        self.salePrice = self.listing.getDetails().salePrice
        // Get a vault from Dapper's account
        self.mainUtilityCoinVault = dapper.borrow<&DapperUtilityCoin.Vault>(from: /storage/dapperUtilityCoinVault)
            ?? panic("Cannot borrow UtilityCoin vault from account storage")
        self.balanceBeforeTransfer = self.mainUtilityCoinVault.balance
        self.paymentVault <- self.mainUtilityCoinVault.withdraw(amount: self.salePrice)
        // Get the collection from the buyer so the NFT can be deposited into it
        self.nftCollection = buyer.borrow<&Magnetiq.Collection{Magnetiq.TokenCollectionPublic,NonFungibleToken.Receiver,NonFungibleToken.CollectionPublic,MetadataViews.ResolverCollection}>(
            from: /storage/MagnetiqTokensCollection
        ) ?? panic("Cannot borrow NFT collection receiver from account")
    }
    // Check that the price is right
    pre {
        self.salePrice == expectedPrice: "unexpected price"
        merchantAccountAddress == 0x160d9cf7eec9f28e: "incorrect dapper merchant account"
    }
    execute {
        let item <- self.listing.purchase(
            payment: <-self.paymentVault,
            commissionRecipient: nil
        )
        self.nftCollection.deposit(token: <-item)
    }
    // Check that all utilityCoin was routed back to Dapper
    post {
        self.mainUtilityCoinVault.balance == self.balanceBeforeTransfer: "UtilityCoin leakage"
    }
}`;

const MAINNET_USER_ACCOUNT_SETUP_TXN = `import NonFungibleToken from 0x1d7e57aa55817448
import Magnetiq from 0x5257f1455ed366fe
import MetadataViews from 0x1d7e57aa55817448

// This transaction sets up an account to use Magnetiq
// by storing an empty moment collection and creating
// a public capability for it

transaction {

    prepare(acct: AuthAccount) {

        // First, check to see if a Magnetiq collection already exists
        if acct.borrow<&Magnetiq.Collection>(from: /storage/MagnetiqTokensCollection) == nil {

            // create a new Magnetiq Collection
            let collection <- Magnetiq.createEmptyCollection() as! @Magnetiq.Collection

            // Put the new Collection in storage
            acct.save(<-collection, to: /storage/MagnetiqTokensCollection)

            // create a public capability for the collection
            acct.link<&{NonFungibleToken.CollectionPublic, Magnetiq.TokenCollectionPublic}>(/public/MagnetiqTokensCollection, target: /storage/MagnetiqTokensCollection)
        }
    }
}`;

function isProduction() {
  return window.location.hostname === "app.magnetiq.xyz";
}
export const USER_ACCOUNT_SETUP_TXN = isProduction() ? MAINNET_USER_ACCOUNT_SETUP_TXN : TESTNET_USER_ACCOUNT_SETUP_TXN;
export const PURCHASE_TRANSACTION = isProduction() ? MAINNET_PURCHASE_TRANSACTION : TESTNET_PURCHASE_TRANSACTION;
